/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Other_S2Inputs */

const en_fc_dl_other_s2 = /** @type {(inputs: Fc_Dl_Other_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test locally: run a static server inside the folder, then open http://localhost:8765.`)
};

/**
* | output |
* | --- |
* | "Test locally: run a static server inside the folder, then open http://localhost:8765." |
*
* @param {Fc_Dl_Other_S2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_other_s2 = /** @type {((inputs?: Fc_Dl_Other_S2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Other_S2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_other_s2(inputs)
});
export { fc_dl_other_s2 as "fc.dl.other.s2" }